// The episode start spans both VA steps; until it is known, this step's entry is the best guess.
// With neither, there is no round: better no done VAs than a wrong set.
export function resolveRoundStart(
    episodeStartedAt: string | null | undefined,
    stepEnteredAt: string | null
): string | null {
    return episodeStartedAt ?? stepEnteredAt;
}
